import React, { useState } from 'react';
import Dots from '../../components/Dots';

const FUNNY_TITLE = 'Rajkumar is a <span>ctrl+z enthusiast</span> and <span>professional googler</span>';
const FUNNY_DESC = "He writes code that works on his machine and asks ChatGPT for the rest";

const Hero = ({ t }) => {
  const [hovered, setHovered] = useState(false);
  const [descHovered, setDescHovered] = useState(false);

  return (
    <section className="hero">
      <div className="hero__content">
        <h1
          className={`hero__title ${hovered ? 'hero__title--hovered' : ''}`}
          dangerouslySetInnerHTML={{ __html: hovered ? FUNNY_TITLE : t.title }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        />
        <div
          className={`hero__description ${descHovered ? 'hero__description--hovered' : ''}`}
          onMouseEnter={() => setDescHovered(true)}
          onMouseLeave={() => setDescHovered(false)}
        >
          {descHovered ? FUNNY_DESC : t.description}
        </div>
        <a className="button button__primary" href="#contacts">{t.button} =&gt;</a>
      </div>
      <div className="hero__illustrations">
        <img src="/images/logo-outline.svg" alt="" className="hero__logo" />
        <img src="/images/hero.png" alt="Elias" className="hero__image" />
        <div className="hero__status">{t.status}</div>
        <Dots />
      </div>
    </section>
  );
};

export default Hero;
